module.exports = __webpack_public_path__ + "media/images/icons/country_flags/si-20c519b47c8f647e7f084ada30a82a4d.svg";